import React from "react";

export default function About() {
  return (
    <section
      id="about"
      className="relative min-h-screen w-full bg-black py-24 px-6"
    >
      {/* Heading */}
      <div className="max-w-6xl mx-auto text-center mb-20">
        <h2 className="text-5xl md:text-6xl font-extrabold tracking-wider text-slate-100">
          About Us
        </h2>
        <p className="mt-6 text-2xl text-slate-300 max-w-4xl mx-auto">
          Perfect Auto Body Works – Complete Auto Body, Mechanical & Interior
          Solutions
        </p>
      </div>

      {/* Cards Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        <GlassCard title="🚙 Vehicles We Service">
          <ul className="space-y-2">
            <li>Cars</li>
            <li>Jeeps</li>
            <li>Tempo / Commercial Vehicles</li>
            <li>Pick-Up Trucks</li>
          </ul>
        </GlassCard>

        <GlassCard title="🚗 Body Repair">
          <ul className="space-y-2">
            <li>Accident & collision repair</li>
            <li>Body panel repair & replacement</li>
            <li>Structural damage correction</li>
            <li>Full body restoration</li>
          </ul>
        </GlassCard>

        <GlassCard title="🎨 Painting">
          <ul className="space-y-2">
            <li>Full & partial painting</li>
            <li>Accurate color matching</li>
            <li>Clear coat & polishing</li>
            <li>Long-lasting finish</li>
          </ul>
        </GlassCard>

        <GlassCard title="🔧 Re-Shaping">
          <ul className="space-y-2">
            <li>Panel straightening</li>
            <li>Dent re-shaping</li>
            <li>Frame alignment</li>
            <li>Body correction</li>
          </ul>
        </GlassCard>

        <GlassCard title="🔩 Welding">
          <ul className="space-y-2">
            <li>Body & chassis welding</li>
            <li>Accident damage welding</li>
            <li>Rust repair</li>
            <li>Structural reinforcement</li>
          </ul>
        </GlassCard>

        <GlassCard title="⚙️ Mechanical">
          <ul className="space-y-2">
            <li>Engine repair & maintenance</li>
            <li>Brake & suspension work</li>
            <li>General mechanical repairs</li>
            <li>Regular servicing</li>
          </ul>
        </GlassCard>

        <GlassCard title="🛋️ Cushion Work">
          <ul className="space-y-2">
            <li>Seat cushion repair</li>
            <li>Foam & padding work</li>
            <li>Interior comfort restoration</li>
            <li>Custom solutions</li>
          </ul>
        </GlassCard>

        <GlassCard title="🔨 Denting">
          <ul className="space-y-2">
            <li>Minor & major dent removal</li>
            <li>Accident dent repair</li>
            <li>Panel correction</li>
            <li>Smooth finishing</li>
          </ul>
        </GlassCard>

        <GlassCard title="🛠️ Alteration & Modification">
          <ul className="space-y-2">
            <li>Custom body alterations</li>
            <li>Design & styling changes</li>
            <li>Utility upgrades</li>
            <li>Performance improvements</li>
          </ul>
        </GlassCard>

        <GlassCard title="🧼 Floor Matting">
          <ul className="space-y-2">
            <li>Custom floor mats</li>
            <li>Rubber & carpet fitting</li>
            <li>Interior protection</li>
            <li>Easy-clean mats</li>
          </ul>
        </GlassCard>

        <GlassCard title="✨ Car Polishing">
          <ul className="space-y-2">
            <li>Machine & hand polishing</li>
            <li>Scratch & swirl removal</li>
            <li>Paint oxidation removal</li>
            <li>High-gloss protection</li>
          </ul>
        </GlassCard>

        <GlassCard title="⭐ Why Choose Us">
          <ul className="space-y-2">
            <li>Experienced technicians</li>
            <li>All vehicle types serviced</li>
            <li>Premium tools & materials</li>
            <li>Reliable & timely work</li>
            <li>Customer satisfaction guaranteed</li>
          </ul>
        </GlassCard>
      </div>
    </section>
  );
}

/* 🔮 Glass Card Component */
function GlassCard({ title, children }) {
  return (
    <div className="bg-white/5 backdrop-blur-xl border border-slate-500/30 rounded-3xl p-8 hover:scale-[1.03] transition duration-300">
      <h3 className="text-2xl font-bold text-slate-100 mb-4 tracking-wide">
        {title}
      </h3>
      <div className="text-lg text-slate-300 leading-relaxed">
        {children}
      </div>
    </div>
  );
}
